/**
 * Menü girdilerine `showUserGroup: ['DEVELOPER']` eklenerek görünürlük
 * kullanıcının grubuna (session.group.code) göre sınırlandırılabilir.
 * Anahtar yoksa girdi herkese açıktır. Süzme: @/core/helpers/menu
 *
 * Backend'de tanımlı grup kodları: DEVELOPER, CONTENT_OWNER
 */
const DocMenuConfig = [
    {
        pages: [
            {
                heading: "dashboard",
                route: "/dashboard",
                fontIcon: "ki-element-11",
            },
            {
                heading: "pages.library",
                route: "/library/",
                menu: "library",
                fontIcon: "ki-folder",
            },
            // Mağaza, plan ve faturalar henüz backend'siz; tasarım kontrolü için
            // herkese açık duruyor. Servisler geldiğinde bunlara da
            // showUserGroup: ["CONTENT_OWNER"] eklenecek.
            {
                heading: "pages.store",
                route: "/store",
                fontIcon: "ki-shop",
            },
            {
                heading: "pages.plan",
                route: "/plan",
                fontIcon: "ki-crown-2",
            },
            {
                heading: "pages.invoices",
                route: "/invoices",
                fontIcon: "ki-bill",
            },
            {
                sectionTitle: "pages.userManagement.title",
                description: "pages.userManagement.description",
                route: "/user-management",
                fontIcon: "ki-users",
                sub: [
                    {
                        heading: "pages.userManagement.company",
                        description: "pages.userManagement.companyDescription",
                        route: "/user-management/company",
                        fontIcon: "ki-office-bag",
                    },
                    {
                        heading: "pages.userManagement.user",
                        description: "pages.userManagement.userDescription",
                        route: "/user-management/user",
                        fontIcon: "ki-users",
                    },
                ],
            },
            {
                sectionTitle: "pages.settings.title",
                description: "pages.settings.description",
                route: "/settings",
                fontIcon: "ki-setting-2",
                sub: [
                    {
                        heading: "pages.settings.general.title",
                        description: "pages.settings.general.description",
                        route: "/settings/general",
                        fontIcon: "ki-setting-3",
                    },
                    {
                        heading: "pages.settings.location.title",
                        description: "pages.settings.location.description",
                        route: "/settings/location",
                        fontIcon: "ki-geolocation",
                    },
                    {
                        heading: "pages.settings.capacity.title",
                        description: "pages.settings.capacity.description",
                        route: "/settings/capacity",
                        fontIcon: "ki-chart-simple",
                    },
                    {
                        heading: "pages.settings.player.title",
                        description: "pages.settings.player.description",
                        route: "/settings/player",
                        fontIcon: "ki-screen",
                    },
                    {
                        heading: "pages.settings.security.title",
                        description: "pages.settings.security.description",
                        route: "/settings/security",
                        fontIcon: "ki-shield-tick",
                    },
                    {
                        heading: "pages.settings.notifications.title",
                        description: "pages.settings.notifications.description",
                        route: "/settings/notifications",
                        fontIcon: "ki-notification-status",
                    },
                ],
            },
            {
                sectionTitle: "pages.developerOptions.title",
                route: "/developer-options",
                fontIcon: "ki-code",
                sub: [
                    {
                        heading: "pages.developerOptions.apiKeys",
                        route: "/developer-options/api-keys",
                    },
                ],
            },
        ],
    },
    {
        heading: "developer.title",
        route: "/developer/",
        showUserGroup: ["DEVELOPER"],
        pages: [
            {
                sectionTitle: "developer.customerManagement.title",
                description: "developer.customerManagement.description",
                route: "/developer/customer-management/",
                fontIcon: "ki-users",
                sub: [
                    {
                        heading: "developer.customerManagement.company.title",
                        description: "developer.customerManagement.company.description",
                        route: "/developer/customer-management/company",
                        fontIcon: "ki-office-bag",
                    },
                    {
                        heading: "developer.customerManagement.customer.title",
                        description: "developer.customerManagement.customer.description",
                        route: "/developer/customer-management/customer",
                        fontIcon: "ki-users",
                    }
                ],
            },
            {
                sectionTitle: "developer.cdnManagement.title",
                description: "developer.cdnManagement.description",
                route: "/developer/cdn-management/",
                fontIcon: "ki-archive",
                sub: [
                    {
                        heading: "developer.cdnManagement.cdnServer.title",
                        description: "developer.cdnManagement.cdnServer.description",
                        route: "/developer/cdn-management/cdn-server",
                        fontIcon: "ki-wifi-square",
                    },
                    // CDN migrate görevlerinin servis karşılığı henüz yok,
                    // uç nokta açıldığında bu girdi de açılacak.
                    /*
                    {
                        heading: "developer.cdnManagement.migrate.title",
                        description: "developer.cdnManagement.migrate.description",
                        route: "/developer/cdn-management/cdn-migrate",
                        fontIcon: "ki-arrows-loop",
                    }
                    */
                ],
            },
            {
                sectionTitle: "developer.videoManagement.title",
                description: "developer.videoManagement.description",
                route: "/developer/video-management/",
                fontIcon: "ki-to-right",
                sub: [
                    {
                        heading: "developer.videoManagement.downloader.title",
                        description: "developer.videoManagement.downloader.description",
                        route: "/developer/video-management/downloader",
                        fontIcon: "ki-cloud-download",
                    },
                    {
                        heading: "developer.videoManagement.converter.title",
                        description: "developer.videoManagement.converter.description",
                        route: "/developer/video-management/converter",
                        fontIcon: "ki-switch",
                    },
                    {
                        heading: "developer.videoManagement.migrate.title",
                        description: "developer.videoManagement.migrate.description",
                        route: "/developer/video-management/migrate",
                        fontIcon: "ki-arrows-loop",
                    },
                ],
            },
            {
                sectionTitle: "developer.workerManagement.title",
                description: "developer.workerManagement.description",
                route: "/developer/worker-management/",
                fontIcon: "ki-setting-2",
                sub: [
                    {
                        heading: "developer.workerManagement.dashboard.title",
                        description: "developer.workerManagement.dashboard.description",
                        route: "/developer/worker-management/dashboard",
                        fontIcon: "ki-chart-line",
                    }
                ],
            },
        ]
    },
];

export default DocMenuConfig;
